module.exports = __webpack_public_path__ + "img/fire.32a70c16.svg";